import {OperationStaffTagsProps} from "./types";
import {Typography} from "antd";
import {UserOutlined} from "@ant-design/icons";

const {Text} = Typography

const OperationStaffTags = (props: OperationStaffTagsProps) => {
  const {names} = props

  if (!names?.length) return <Text type="secondary">-</Text>

  return <span className="operation-staff-tags">
    {names.map((name) => <span className="operation-staff-tag" key={name}>
      <UserOutlined/> {name}
    </span>)}
  </span>
}

export default OperationStaffTags
